import { Space, Table, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import './Users.css';
import { useNavigate } from 'react-router-dom';
import { useQuery, gql } from '@apollo/client';

const GET_VEHICLES = gql`
  query GetVehicles {
    vehicles {
      id
      plate
      vehicle
      license
      citizenid
      hash
      garage
      drivingdistance
      supporter
    }
  }
`;

function App() {
  const { data, error, loading: isFetching } = useQuery(GET_VEHICLES);
  const [vehicles, setVehicles] = useState([]);
  const [searchText, setSearchText] = useState('');

  const navigate = useNavigate();

  const columns = [
    {
      title: 'Plate',
      dataIndex: 'plate',
    },
    {
      title: 'Vehicle',
      dataIndex: 'vehicle',
    },
    {
      title: 'License',
      dataIndex: 'license',
    },
    {
      title: 'Citizen ID',
      dataIndex: 'citizenid',
    },
    {
      title: 'Model hash',
      dataIndex: 'hash',
    },
    {
      title: 'Garage',
      dataIndex: 'garage',
    },
    {
      title: 'Miles',
      dataIndex: 'drivingdistance',
      sorter: (a, b) => a.drivingdistance - b.drivingdistance,
    },
    {
      title: 'Supporter',
      dataIndex: 'supporter',
      sorter: (a, b) => a.supporter - b.supporter,
    },
  ];

  useEffect(() => {
    if (!isFetching && data) {
      if (data.vehicles) {
        setVehicles(data.vehicles);
      }
    }
  }, [data, isFetching]);

  useEffect(() => {
    if (searchText && (data && data.vehicles)) {
      const filteredVehicles = data.vehicles.filter((vehicle) => {
        return (vehicle?.plate?.toLowerCase().includes(searchText.toLowerCase())
          || vehicle?.vehicle?.toLowerCase().includes(searchText.toLowerCase())
          || vehicle?.license?.toLowerCase().includes(searchText.toLowerCase())
          || vehicle?.citizenid?.toLowerCase().includes(searchText.toLowerCase())
          || vehicle?.garage?.toLowerCase().includes(searchText.toLowerCase())
          || vehicle?.supporter?.toLowerCase().includes(searchText.toLowerCase()));
      });

      setVehicles(filteredVehicles);
    } else {
      setVehicles(data?.vehicles);
    }
  }, [searchText, data]);

  const onTableChange = (pagination, filters, sorter, extra) => {
    console.log(pagination, filters, sorter, extra)
  }

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <div>
        <h1>Vehicles</h1>
        <p>A list of all vehicles registered. <i>(Click on a vehicle to view details)</i></p>
      </div>
      <Input
        type="text"
        value={searchText}
        prefix={<SearchOutlined />}
        onChange={(e) => setSearchText(e.target.value)}
        placeholder="Search"
        style={{ width: '300px' }}
      />
      <Table
        columns={columns}
        dataSource={vehicles}
        loading={isFetching}
        rowKey="id"
        onRow={(record, rowIndex) => {
          return {
            onClick: event => {
              navigate(`/admin/vehicles/${record.plate}`);
            },
          };
        }}
        onChange={onTableChange}
      />
    </Space>
  );
}

export default App;
